<div class="efx-toast w-100 animate__animated animate__zoomIn"
  [class.component-mode-container]="config.mode === 'component'"
  [ngClass]="(config.mode !== 'component') ? 'toast-' + config.type + ' w-100' : 'w-100'"
  [style.max-width]="config.maxWidth"
  >
  <div
    class="position-relative d-flex align-items-center"
    [ngClass]="(config.mode === 'component') ? '' : 'p-3'"
    >
    @if (config.mode === 'component') {
      <div>
        <div class="toast-content position-relative">
          <efx-alert type="{{config.type}}" [isClosable]="config.isClosable">
            <div class="alert-title">{{ config.title || '' }}</div>
            {{ config.description || '' }}
          </efx-alert>
        </div>
      </div>
    } @else {
      <div class="toast-icon" [style.color]="config.color">
        <span class="material-symbols-outlined"> {{ getIcon() }} </span>
      </div>
      <div class="toast-content" [style.color]="config.color">
        <div class="toast-title">{{ config.title || '' }}</div>
        <div class="toast-description">{{ config.description || '' }}</div>
      </div>
    }


    @if (config.isClosable) {
      <button (click)="dismiss()" class="close-button"
        [ngClass]="config.mode === 'component' ? 'd-none':''" [style.color]="config.color">
        <span class="material-symbols-outlined">close</span>
      </button>
    }
  </div>

</div>